import { IAttachColumn, IAttachRow } from './AttachGrid.types';

/** Схема отдаёт `field` как dot-path к строке (напр. `fields.AttachmentFileName`),
 *  а значения лежат в `row.fields` по ключу без префикса. Снимаем префикс для чтения.
 *  Для запросов (sort/filter/fields) поле используется как есть — это контракт бэка. */
export const fieldKey = (field: string): string => field.replace(/^fields\./, '');

/** Значение ячейки строки по `field` колонки (поля схемы — динамические, `any`). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rowValue = (row: IAttachRow, field: string): any => row.fields[fieldKey(field)];

/** Ключ адресной книги для ФИО-колонки: из синтетического поля `userKeyField`
 *  (голый ключ; префикс снимаем на всякий случай). Системные/пустые (0/-1/'')
 *  и второй+ исполнитель → undefined (без hover). */
export function userKeyOf(column: IAttachColumn, row: IAttachRow): string | undefined {
    if (!column.userKeyField) return undefined;
    const raw = row.fields[fieldKey(column.userKeyField)];
    if (raw == null || raw === '' || raw === '0' || raw === '-1') return undefined;
    const first = String(raw).split(',')[0].trim();
    return first === '0' || first === '-1' || first === '' ? undefined : first;
}

/** Статус публикации: текст + признак «опубликован» (зелёный). «Не публикуется» → нет.
 *  Префикс «не» проверяем как `^не` без `\b` — в JS границы слов не работают с кириллицей. */
export function publicationInfo(value: unknown): { text: string; published: boolean } {
    const text = value == null ? '' : String(value).trim();
    const published = !!text && /публик|опубликован/i.test(text) && !/^не/i.test(text);
    return { text, published };
}

/** Первая видимая колонка — «имя файла» (получает марку типа + заголовок). */
export function primaryColumn(columns: IAttachColumn[]): IAttachColumn | undefined {
    return columns.find((c) => c.show);
}

/** Имя файла строки (для извлечения расширения и марки). */
export function rowFileName(row: IAttachRow, primaryField?: string): string {
    const v = row.fields['AttachmentFileName'] ?? (primaryField ? rowValue(row, primaryField) : undefined);
    return typeof v === 'string' ? v : '';
}

/** Расширение из имени файла. */
export function extOf(name: string): string {
    const i = name.lastIndexOf('.');
    return i > 0 ? name.slice(i + 1) : '';
}
